import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { LocalStorageService } from '../../services/local-storage.service';
import { EFooterStyleInput } from '../../data-types/footer.enum';
import { EStorageType } from '../../data-types/storage.enum';
import { UserService } from '../../services/user.service';
import { IAppState } from '../../store/state/app.state';
import { iconsLibrary } from '../../../theme/constants';

@Component({
  selector: 'cowing-core-company-home',
  templateUrl: './company-home.component.html',
  styleUrls: ['./company-home.component.scss'],
})
export class CompanyHomeComponent {
  public EFooterStyleInput = EFooterStyleInput;
  public companyId;
  public coworkingId;
  public content: string = null;
  private tokenRefreshed = false;

  constructor(private _store: Store<IAppState>, private _router: Router) {
    let currentContent = 'employees';

    _router.events.subscribe((val) => {
      if (this._router.url.includes('home')) { currentContent = 'home'; }
      if (this._router.url.includes('employees')) { currentContent = 'employees'; }
      if (this._router.url.includes('booking')) { currentContent = 'booking'; }
      if (this._router.url.includes('spendings')) { currentContent = 'spendings'; }
      if (this._router.url.includes('spaces')) { currentContent = 'spaces'; }
      this.content = currentContent;
    });
  }
  ngOnInit() {
    this.companyId = LocalStorageService.instance.get(
      EStorageType.ActiveCompany
    );
    this.coworkingId = LocalStorageService.instance.get(
      EStorageType.ActiveCoworking
    );
  }
  public get getConfirmation() {
    return `${iconsLibrary.confirm}`;
  }

  public get getUserType() {
    if (this.companyId && this.coworkingId) {
      return 'company-plus';
    }
    return 'company';
  }
}
